module.exports = __webpack_public_path__ + "img/09n.78b77aaa.png";